const BREAKPOINT = 1024;

const STATE = {
	STEP_PARKINGS: 'stepParkings',
	STEP_FLOORS_BIRD: 'stepFloorsBirds',
	STEP_FLOORS_SCHEME: 'stepFloorsScheme',
};

const COMPONENT_CLASS = {
	STEP_PARKINKGS: 'parkings',
	STEP_FLOORS: 'floors',
	STATE_SCHEME: 'scheme',
	FILTERS_OPEN: 'filters-open',
	LOADING: 'loading',
};

const STATE_COMPONENT_CLASSES = [
	COMPONENT_CLASS.STEP_PARKINKGS,
	COMPONENT_CLASS.STEP_FLOORS,
	COMPONENT_CLASS.STATE_SCHEME,
];

const NODE_NAME = {
	COMPONENT: 'component',
	COUNT_PLACES_LABEL: 'countPlacesLabel',
	BACK_TO_PARKINGS_BUTTON: 'backToParkingsButtons',
	PARKINGS_TOGGLE_WRAPPER: 'parkingsToggleWrapper',
	PARKINGS_TOGGLE_BUTTON: 'parkingsToggleButton',
	PARKINGS_TOGGLE_LIST: 'parkingsToggleList',
	FILTERS_BUTTON: 'filtersButton',
	FILTERS_RESET_BUTTON: 'filtersResetButton',
	FILTERS_WRAPPER: 'filtersWrapper',
	FILTERS_RANGE_WRAPPER: 'filtersRangeWrapper',
	FILTERS_COUNT_PLACES_LABEL: 'filtersCountPlacesLabel',
	FILTERS_APPLY_BUTTON: 'filtersApplyButton',
	FILTERS_CLOSE_BUTTON: 'filtersCloseButton',
	PARKINGS_LIST: 'parkingsList',
	INTERACTIVE_WRAPPER: 'interactiveWrapper',
	TOOLTIP: 'tooltip',
	BIRD: 'bird',
	BIRD_SVG: 'birdSvg',
	BIRD_SVG_PARKINGS: 'birdSvgParkings',
	SCHEME: 'scheme',
	SCHEME_SVG: 'schemeSvg',
	BOOK_PARKING_FORM: 'bookParkingForm',
	BOOK_PARKING_FORM_SUBMIT_BUTTON: 'bookParkingFormSubmitButton',
	BOOK_PARKING_FORM_INPUT_GUID: 'bookParkingFormInputGuid',
	JSON_CONTAINER: 'jsonContainer',
};

const COMPONENT_DATA_KEY = {
	NODES: 'nodes',
	CURRENT_STATE: 'currentState',
	COMPLEX_DATA: 'complexData',
	CURRENT_PARKING_GUID: 'currentParkingGuid',
	CURRENT_FLOOR_NUMBER: 'curentFloorNumber',
	SCHEMES: 'schemes',
};

const FILTERS = {
	MIN_PRICE: 'min_price',
	MAX_PRICE: 'max_price',
};

const ONE_PARKING_CLASS = 'one-parking';
const PARKING_WRAPPER_CURRENT_CLASS = 'current';
const PARKING_WRAPPER_HIGHLIGHT_CLASS = 'highlight';
const BIRD_PARKING_SELECT_CLASS = 'select';
const BIRD_PARKING_HiGHLIGHT_CLASS = 'highlight';

const TOOLTIP_SHOW_CLASS = 'show';

const JSON_CONTAINER_DATA_ATTRIBUTE = 'data-json';
const GUID_ATTRIBUTE = 'data-guid';
const FLOOR_NUMBER_ATTRIBUTE = 'data-floor-number';
const PLACE_PRICE_ATTRIBUTE = 'data-price';
const PLACE_ENABLED_ATTRIBUTE = 'data-enabled';
const PLACE_NUMBER_ATTRIBUTE = 'data-number';

const COMPONENT_SELECTOR = 'section.cds2-parking';
const JSON_CONTAINER_SELECTOR = `span.json-container[${JSON_CONTAINER_DATA_ATTRIBUTE}]`;
const BIRD_SVG_PARKING_WRAPPER_SELECTOR = '#Parking';
const PARKING_WRAPPER_SELECTOR = 'li.parking-wrapper';
const PARKING_REGION_SELECTOR = `${BIRD_SVG_PARKING_WRAPPER_SELECTOR} > g[id^="PRK-"]`;
const PARKINGS_TOGGLE_BUTTON_SELECTOR = 'button.toggle';

const COMPLEX_FILTERED_DATA_KEY = 'filtered_data';

const getParkingGuidFromRegion = ( region ) => {
	if ( region )
	{
		const match = region.getAttribute( 'id' ).match( /PRK-(?<guid>.+)/u );
		
		if ( match && match.groups && match.groups.guid )
		{
			return match.groups.guid;
		}
	}
	
	return '';
};

const createRubString = ( digit, priceSuffix = '₽' ) => {
	return String( digit ).replace( /\B(?=(\d{3})+(?!\d))/g, ' ' ) + ' ' + priceSuffix;
};

const getMinPriceString = ( digit ) => {
	return digit > 0 ? `от&nbsp;${createRubString( digit )}` : 'Цена по запросу';
};

const isTouchDevice = () => {
	return 'ontouchstart' in window || navigator.maxTouchPoints;
};

const openBookForm = ( componentData, guid ) => {
	if ( guid )
	{
		const inputGuid = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BOOK_PARKING_FORM_INPUT_GUID];
		const submitButton = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BOOK_PARKING_FORM_SUBMIT_BUTTON];
		
		inputGuid.value = guid;
		
		submitButton.click();
	}
};

const removeAllStateComponentClasess = ( nodes ) => {
	if ( !nodes )
	{
		return;
	}
	
	Object.values( STATE_COMPONENT_CLASSES ).forEach( ( className ) => {
		nodes[NODE_NAME.COMPONENT].classList.remove( className );
	} );
};

// const setNewState = ( componentData, state ) => {
	
// };

const removeSelectParkingAtBird = ( componentData ) => {
	const parkings = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD_SVG_PARKINGS];
	
	parkings.querySelectorAll( `g.${BIRD_PARKING_SELECT_CLASS}` )
		.forEach( ( selectedRegion ) => selectedRegion.classList.remove( BIRD_PARKING_SELECT_CLASS ) );
};

const setSelectParkingAtBird = ( componentData ) => {
	const parkingGuid = componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID];
	const parkings = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD_SVG_PARKINGS];
	
	if ( !parkingGuid || !parkings )
	{
		return;
	}
	
	const region = parkings.querySelector( `[id="PRK-${parkingGuid}"]` );
	
	if ( region )
	{
		removeSelectParkingAtBird( componentData );
		
		region.classList.add( BIRD_PARKING_SELECT_CLASS );
	}
};

const removeCurrentParkingAtList = ( componentData ) => {
	const parkingList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_LIST];
	
	parkingList.querySelectorAll( `${PARKING_WRAPPER_SELECTOR}.${PARKING_WRAPPER_CURRENT_CLASS}` )
		.forEach( ( node ) => node.classList.remove( PARKING_WRAPPER_CURRENT_CLASS ) );
};

const setCurrentParkingAtList = ( componentData ) => {
	const parkingList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_LIST];
	const parkingGuid = componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID];
	
	removeCurrentParkingAtList( componentData );
	
	const newCurrentParkingWrapper = parkingList.querySelector( `${PARKING_WRAPPER_SELECTOR}[${GUID_ATTRIBUTE}="${parkingGuid}"]` );
	
	if ( newCurrentParkingWrapper )
	{
		newCurrentParkingWrapper.classList.add( PARKING_WRAPPER_CURRENT_CLASS );
	}
};

const setNewParkingToggle = ( componentData ) => {
	const parkingGuid = componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID];
	const parkingsToggleButton = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_TOGGLE_BUTTON];
	const parkingsToggleList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_TOGGLE_LIST];
	
	const selectClass = 'select';
	
	const selectedParking = parkingsToggleList.querySelector( `li.${selectClass}` );
	
	if ( selectedParking )
	{
		selectedParking.classList.remove( selectClass );
	}
	
	const newParking = parkingsToggleList.querySelector( `li[${GUID_ATTRIBUTE}="${parkingGuid}"]` );
	
	if ( newParking )
	{
		newParking.classList.add( selectClass );
		
		parkingsToggleButton.innerHTML = newParking.innerHTML;
	}
};

const initParkingsToggle = ( componentData ) => {
	const parkingsToggleWrapper = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_TOGGLE_WRAPPER];
	const parkingsToggleButton = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_TOGGLE_BUTTON];
	const parkingsToggleList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_TOGGLE_LIST];
	const component = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.COMPONENT];
	
	const openedClass = 'open';
	const parkingSelector = `li[${GUID_ATTRIBUTE}]`;
	
	const toggleBookletOpenClass = ( evt ) => {
		evt.preventDefault();
		evt.stopPropagation();
		evt.stopImmediatePropagation();
		
		parkingsToggleWrapper.classList.toggle( openedClass );
	};
	
	document.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.closest( `${COMPONENT_SELECTOR} ${PARKINGS_TOGGLE_BUTTON_SELECTOR}` ) )
		{
			parkingsToggleWrapper.classList.remove( openedClass );
		}
	} );
	
	if ( !component.classList.contains( ONE_PARKING_CLASS ) )
	{
		parkingsToggleButton.addEventListener( 'click', toggleBookletOpenClass );
	}
	
	parkingsToggleList.addEventListener( 'click', ( evt ) => {
		const parking = evt.target.closest( parkingSelector );
		
		if ( parking )
		{
			componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = parking.getAttribute( GUID_ATTRIBUTE );
			
			setStateFloorsScheme( componentData );
		}
	} );
	
	const hangleResize = () => {
		if ( window.innerWidth < BREAKPOINT )
		{
			if ( !componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] )
			{
				const parking = parkingsToggleList.querySelector( `li[${GUID_ATTRIBUTE}]` );
				
				if ( parking )
				{
					componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = parking.getAttribute( GUID_ATTRIBUTE );
				}
			}
			
			setStateFloorsScheme( componentData );
		}
	};
	
	window.addEventListener( 'resize', hangleResize );
	hangleResize();
};

const setAvailablePlaces = ( componentData, parkingGuid, floorNumber ) => {
	const scheme = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.SCHEME];
	const filteredData = componentData[COMPONENT_DATA_KEY.COMPLEX_DATA][COMPLEX_FILTERED_DATA_KEY];
	const svg = scheme.querySelector( 'svg' );
	
	if ( !svg )
	{
		return;
	}
	
	Object.values( filteredData[parkingGuid].floors[floorNumber] ).forEach( ( placeData ) => {
		const placeNode = svg.querySelector( `#Parking *[id="PAR-${placeData.number}"]` );
		
		if ( placeNode )
		{
			placeNode.setAttribute( GUID_ATTRIBUTE, placeData.guid );
			placeNode.setAttribute( PLACE_NUMBER_ATTRIBUTE, placeData.number );
			placeNode.setAttribute( PLACE_PRICE_ATTRIBUTE, placeData.hide_price === 'yes' ? 'По запросу' : createRubString( parseInt( placeData.price_full_payment, 10 ) ) );
			placeNode.setAttribute( PLACE_ENABLED_ATTRIBUTE, 'yes' );
		}
	} );
};

const initNewSchemeSvg = ( componentData ) => {
	const scheme = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.SCHEME];
	const complexData = componentData[COMPONENT_DATA_KEY.COMPLEX_DATA];
	const svg = scheme.querySelector( 'svg' );
	
	if ( !svg )
	{
		return;
	}
	
	const parkingGuid = scheme.getAttribute( GUID_ATTRIBUTE );
	const floorNumber = scheme.getAttribute( FLOOR_NUMBER_ATTRIBUTE );
	
	setAvailablePlaces( componentData, parkingGuid, floorNumber );
	
	// TODO: Сохранять ранее загруженные схемы
	// if ( !componentData[COMPONENT_DATA_KEY.SCHEMES][parkingGuid] )
	// {
	// 	componentData[COMPONENT_DATA_KEY.SCHEMES][parkingGuid] = {};
	// }
	
	// componentData[COMPONENT_DATA_KEY.SCHEMES][parkingGuid][floorNumber] = svg.outerHTML;
};

const setNewSvgScheme = ( componentData, parkingGuid, floorNumber ) => {
	const scheme = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.SCHEME];
	const filteredData = componentData[COMPONENT_DATA_KEY.COMPLEX_DATA][COMPLEX_FILTERED_DATA_KEY];
	const schemeSrc = filteredData[parkingGuid].floors[floorNumber]['schemeSrc'];
	
	fetch( schemeSrc )
		.then( ( response ) => {
			if ( response.status === 200 )
			{
				return response.text();
			}
			
			return '<p class="no-exist">Схема отсуствует</p>';
		} )
		.then( ( result ) => {
			scheme.innerHTML = result;
			scheme.setAttribute( GUID_ATTRIBUTE, parkingGuid );
			scheme.setAttribute( FLOOR_NUMBER_ATTRIBUTE, floorNumber );
			
			initNewSchemeSvg( componentData );
		} );
};

const setStateFloorsScheme = ( componentData ) => {
	const nodes = componentData[COMPONENT_DATA_KEY.NODES];
	const filteredData = componentData[COMPONENT_DATA_KEY.COMPLEX_DATA][COMPLEX_FILTERED_DATA_KEY];
	
	componentData[COMPONENT_DATA_KEY.CURRENT_STATE] = STATE.STEP_FLOORS_SCHEME;
	
	removeAllStateComponentClasess( nodes );
	
	nodes[NODE_NAME.COMPONENT].classList.add( COMPONENT_CLASS.STEP_FLOORS );
	nodes[NODE_NAME.COMPONENT].classList.add( COMPONENT_CLASS.STATE_SCHEME );
	
	setCurrentParkingAtList( componentData );
	
	const parkingGuid = componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID];
	
	// if ( !parkingGuid )
	// {
	// 	parkingGuid = Object.keys( filteredData )[0];
	// 	componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = parkingGuid;
	// }
	
	const floorKey = Object.keys( filteredData[parkingGuid].floors )[0];
	
	if ( floorKey !== null && typeof floorKey !== 'undefined' )
	{
		setNewSvgScheme( componentData, parkingGuid, floorKey );
	}
	
	setNewParkingToggle( componentData );
};

const setStateFloorsBird = ( componentData ) => {
	const nodes = componentData[COMPONENT_DATA_KEY.NODES];
	
	componentData[COMPONENT_DATA_KEY.CURRENT_STATE] = STATE.STEP_FLOORS_BIRD;
	
	removeAllStateComponentClasess( nodes );
	
	nodes[NODE_NAME.COMPONENT].classList.add( COMPONENT_CLASS.STEP_FLOORS );
	
	setSelectParkingAtBird( componentData );
	setCurrentParkingAtList( componentData );
	setNewParkingToggle( componentData );
};

const setStateParkings = ( componentData ) => {
	const nodes = componentData[COMPONENT_DATA_KEY.NODES];
	
	componentData[COMPONENT_DATA_KEY.CURRENT_STATE] = STATE.STEP_PARKINGS;
	
	removeAllStateComponentClasess( nodes );
	
	nodes[NODE_NAME.COMPONENT].classList.add( COMPONENT_CLASS.STEP_PARKINKGS );
	
	removeCurrentParkingAtList( componentData );
	removeSelectParkingAtBird( componentData );
	
	componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = null;
	
	setNewParkingToggle( componentData );
};

const setStateLoading = ( componentData ) => {
	componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.COMPONENT].classList.add( COMPONENT_CLASS.LOADING );
};

const removeStateLoading = ( componentData ) => {
	componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.COMPONENT].classList.remove( COMPONENT_CLASS.LOADING );
};

const initBackToParkingsButton = ( componentData ) => {
	const backToParkingsButton = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BACK_TO_PARKINGS_BUTTON];
	
	backToParkingsButton.addEventListener( 'click', () => {
		componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = null;
		setStateParkings( componentData );
		scrollToParking( componentData );
	} );
};

const setTooltipCoords = ( componentData, offsetX, offsetY ) => {
	const tooltip = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.TOOLTIP];
	const interactiveWrapper = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.INTERACTIVE_WRAPPER];
	
	const tooltipInverseClass = 'inverse';
	const adTopOffset = 48;
	const adHeightOffset = 20;
	const tooltipRect = tooltip.getBoundingClientRect();
	const fullOffsetTop = offsetY + adTopOffset;
	const fullHeight = fullOffsetTop + tooltipRect.height + adHeightOffset;
	
	tooltip.style.top = `${fullOffsetTop}px`;
	tooltip.style.left = `${offsetX}px`;
	
	if ( fullHeight > interactiveWrapper.offsetHeight )
	{
		tooltip.classList.add( tooltipInverseClass );
		tooltip.style.top = `${offsetY - ( adTopOffset / 2 )}px`;
	}
	else
	{
		tooltip.classList.remove( tooltipInverseClass );
	}
};

const setTooltipInfo = ( componentData, title, priceString ) => {
	const tooltip = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.TOOLTIP];
	const tooltipTitleNode = tooltip.querySelector( 'h3' );
	const priceNode = tooltip.querySelector( 'p.price' );
	
	if ( !tooltipTitleNode || !priceNode )
	{
		return;
	}
	
	tooltipTitleNode.innerHTML = title;
	priceNode.innerHTML = priceString;
};

const hideTooltip = ( componentData ) => {
	const tooltip = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.TOOLTIP];
	
	tooltip.classList.remove( TOOLTIP_SHOW_CLASS );
	tooltip.removeAttribute( GUID_ATTRIBUTE );
	
	tooltip.style.top = '0px';
	tooltip.style.left = '0px';
};

const showTooltip = ( componentData, title, priceString, offsetX = 0, offsetY = 0 ) => {
	const tooltip = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.TOOLTIP];
	
	setTooltipInfo( componentData, title, priceString );
	setTooltipCoords( componentData, offsetX, offsetY );
	tooltip.classList.add( TOOLTIP_SHOW_CLASS );
};

const removeHighlightParkingAtList = ( componentData ) => {
	const parkingList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_LIST];
	const highlightParkingWrapper = parkingList.querySelector( `${PARKING_WRAPPER_SELECTOR}.${PARKING_WRAPPER_HIGHLIGHT_CLASS}` );
	
	if ( highlightParkingWrapper )
	{
		highlightParkingWrapper.classList.remove( PARKING_WRAPPER_HIGHLIGHT_CLASS );
	}
};

const highlightParkingAtList = ( componentData, parkingGuid ) => {
	const parkingList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_LIST];
	const parkingWrapper = parkingList.querySelector( `${PARKING_WRAPPER_SELECTOR}[${GUID_ATTRIBUTE}="${parkingGuid}"]` );
	
	if ( parkingWrapper )
	{
		removeHighlightParkingAtList( componentData );
		parkingWrapper.classList.add( PARKING_WRAPPER_HIGHLIGHT_CLASS );
	}
};

const initScheme = ( componentData ) => {
	const scheme = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.SCHEME];
	const tooltip = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.TOOLTIP];
	const enabledPlaceSelector = `#Parking > *[id^="PAR-"][${GUID_ATTRIBUTE}][${PLACE_PRICE_ATTRIBUTE}][${PLACE_NUMBER_ATTRIBUTE}][${PLACE_ENABLED_ATTRIBUTE}="yes"]`;
	
	initNewSchemeSvg( componentData );
	
	scheme.addEventListener( 'click', ( evt ) => {
		const place = evt.target.closest( enabledPlaceSelector );
		
		if ( place )
		{
			const guid = place.getAttribute( GUID_ATTRIBUTE );
			
			openBookForm( componentData, guid );
		}
	} );
	
	// scheme.addEventListener( 'click', ( evt ) => {
	// 	// if ( isTouchDevice() )
	// 	// {
	// 	// 	return;
	// 	// }
		
	// 	const place = evt.target.closest( enabledPlaceSelector );
	// 	const svg = evt.target.closest( 'svg' );
		
	// 	if ( place && svg )
	// 	{
	// 		const number = place.getAttribute( PLACE_NUMBER_ATTRIBUTE );
	// 		const price = place.getAttribute( PLACE_PRICE_ATTRIBUTE );
	// 		// const offset = parseInt( window.getComputedStyle( svg ).borderWidth, 10 );
			
	// 		// const offsetX = evt.offsetX + offset;
	// 		// const offsetY = evt.offsetY + offset;
			
	// 		const svgRect = svg.getBoundingClientRect();
	// 		const placeRect = place.getBoundingClientRect();
	// 		const offsetX = placeRect.x - svgRect.x;
	// 		const offsetY = placeRect.y;
			
	// 		setTooltipInfo( componentData, `Паркинг №${number}`, createRubString( price ) );
	// 		setTooltipCoords( componentData, offsetX, offsetY );
			
	// 		tooltip.classList.add( TOOLTIP_SHOW_CLASS );
	// 	}
	// } );
	
	// scheme.addEventListener( 'mouseout', ( evt ) => {
	// 	const place = evt.target.closest( enabledPlaceSelector );
		
	// 	if ( !place )
	// 	{
	// 		hideTooltip( componentData );
	// 	}
	// } );
	
	scheme.addEventListener( 'mousemove', ( evt ) => {
		const place = evt.target.closest( enabledPlaceSelector );
		
		const offsetX = evt.offsetX + 80;
		const offsetY = evt.offsetY + 80;

		if ( place )
		{
			const currentGuid = tooltip.getAttribute( GUID_ATTRIBUTE );
			const placeGuid = place.getAttribute( GUID_ATTRIBUTE );

			if ( currentGuid === placeGuid )
			{
				setTooltipCoords( componentData, offsetX, offsetY );
			}
			else
			{
				tooltip.setAttribute( GUID_ATTRIBUTE, placeGuid );

				const number = `Паркинг №${place.getAttribute( PLACE_NUMBER_ATTRIBUTE )}`;
				const priceString = place.getAttribute( PLACE_PRICE_ATTRIBUTE );
				
				showTooltip( componentData, number, priceString, offsetX, offsetY );
			}
		}
		else if ( tooltip.classList.contains( TOOLTIP_SHOW_CLASS ) )
		{
			if ( place )
			{
				setTooltipCoords( componentData, offsetX, offsetY );
			}
			else
			{
				hideTooltip( componentData );
			}
		}
	} );
};

const scrollToParking = ( componentData ) => {
	const parkings = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD_SVG_PARKINGS];
	const interactiveWrapper = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.INTERACTIVE_WRAPPER];

	if ( parkings )
	{
		interactiveWrapper.scrollTo( {
			left: parkings.getBoundingClientRect().x - interactiveWrapper.offsetLeft,
			behavior: 'smooth',
		} );
	}
};

const initParkingsList = ( componentData ) => {
	const parkingList = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.PARKINGS_LIST];
	const parkingsBird = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD_SVG_PARKINGS];
	
	parkingList.addEventListener( 'click', ( evt ) => {
		const parkingLabel = evt.target.closest( 'div.parking-label' );
		const floorWrapper = evt.target.closest( 'li.floor-wrapper:not( .sold )' );
		const pricesWrapper = evt.target.closest( 'li.price-group-wrapper' );
		
		if ( parkingLabel )
		{
			if ( componentData[COMPONENT_DATA_KEY.CURRENT_STATE] === STATE.STEP_PARKINGS )
			{
				const parkingWrapper = parkingLabel.closest( `${PARKING_WRAPPER_SELECTOR}[${GUID_ATTRIBUTE}]` );
				
				if ( parkingWrapper )
				{
					const parkingGuid = parkingWrapper.getAttribute( GUID_ATTRIBUTE );
					
					componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = parkingGuid;
					
					setStateFloorsBird( componentData );
					scrollToParking( componentData );
				}
			}
			else
			{
				const buttonSwitch = evt.target.closest( 'button.mode-switch' );
				
				if ( buttonSwitch )
				{
					if ( componentData[COMPONENT_DATA_KEY.CURRENT_STATE] === STATE.STEP_FLOORS_BIRD )
					{
						setStateFloorsScheme( componentData );
					}
					else if ( componentData[COMPONENT_DATA_KEY.CURRENT_STATE] === STATE.STEP_FLOORS_SCHEME )
					{
						setStateFloorsBird( componentData );
						scrollToParking( componentData );
					}
				}
			}
		}
		else if ( floorWrapper )
		{
			if ( componentData[COMPONENT_DATA_KEY.CURRENT_STATE] === STATE.STEP_FLOORS_BIRD )
			{
				const parkingGuid = floorWrapper.getAttribute( GUID_ATTRIBUTE );
				
				openBookForm( componentData, parkingGuid );
			}
			else if ( componentData[COMPONENT_DATA_KEY.CURRENT_STATE] === STATE.STEP_FLOORS_SCHEME )
			{
				const parkingGuid = floorWrapper.getAttribute( GUID_ATTRIBUTE );
				const floorNumber = floorWrapper.getAttribute( FLOOR_NUMBER_ATTRIBUTE );
				
				setNewSvgScheme( componentData, parkingGuid, floorNumber );
			}
		}
		else if ( pricesWrapper )
		{
			const parkingGuid = componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID];
			
			openBookForm( componentData, parkingGuid );
		}
	} );
	
	const removeHighlightFromBirdParking = () => {
		const highlighParking = parkingsBird.querySelector( `.${BIRD_PARKING_HiGHLIGHT_CLASS}[id*="PRK-"]` );
		
		if ( highlighParking )
		{
			highlighParking.classList.remove( BIRD_PARKING_HiGHLIGHT_CLASS );
		}
	};
	
	parkingList.addEventListener( 'mousemove', ( evt ) => {
		if ( !parkingsBird )
		{
			return;
		}

		const hoverParking = evt.target.closest( `${PARKING_WRAPPER_SELECTOR}[${GUID_ATTRIBUTE}]` );
		
		if ( hoverParking )
		{
			const parkingGuid = hoverParking.getAttribute( GUID_ATTRIBUTE );
			const newBirdParking = parkingsBird.querySelector( `[id="PRK-${parkingGuid}"]` );
			
			if ( newBirdParking )
			{
				removeHighlightFromBirdParking();
				
				newBirdParking.classList.add( BIRD_PARKING_HiGHLIGHT_CLASS );
			}
		}
		else
		{
			removeHighlightFromBirdParking();
		}
	} );
};

const initBird = ( componentData ) => {
	const svg = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD_SVG];

	if ( !svg )
	{
		return;
	}
	
	const filteredData = componentData[COMPONENT_DATA_KEY.COMPLEX_DATA][COMPLEX_FILTERED_DATA_KEY];
	const bird = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD];
	const parkingsWrapper = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.BIRD_SVG_PARKINGS];
	const tooltip = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.TOOLTIP];
	const complexData = componentData[COMPONENT_DATA_KEY.COMPLEX_DATA];
	const interactiveWrapper = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.INTERACTIVE_WRAPPER];
	
	const buildings = svg.querySelector( '#Buildings' );
	
	if ( buildings )
	{
		buildings.remove();
	}

	if ( parkingsWrapper )
	{
		Array.from( parkingsWrapper.children ).forEach( ( parkingNode ) => {
			const guid = getParkingGuidFromRegion( parkingNode );
			
			if ( !filteredData[guid] )
			{
				parkingNode.remove();
			}
		} );
	}
	
	svg.addEventListener( 'click', ( evt ) => {
		const parkingRegion = evt.target.closest( PARKING_REGION_SELECTOR );
		
		const guid = getParkingGuidFromRegion( parkingRegion );
			
		if ( guid )
		{
			componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = guid;
			
			setStateFloorsBird( componentData );
		}
	} );
	
	if ( parkingsWrapper )
	{
		parkingsWrapper.addEventListener( 'mouseover', ( evt ) => {
			if ( isTouchDevice() )
			{
				return;
			}
			
			const parkingRegion = evt.target.closest( PARKING_REGION_SELECTOR );
			
			if ( parkingRegion )
			{
				const parkingGuid = getParkingGuidFromRegion( parkingRegion );
				
				showTooltip(
					componentData,
					filteredData[parkingGuid].nameParking,
					getMinPriceString( filteredData[parkingGuid].minPrice ),
					evt.offsetX,
					evt.offsetY,
				);
				
				highlightParkingAtList( componentData, parkingGuid );
			}
		} );
		
		parkingsWrapper.addEventListener( 'mouseleave', ( evt ) => {
			const region = evt.target.closest( PARKING_REGION_SELECTOR );
			
			if ( !region )
			{
				hideTooltip( componentData );
				removeHighlightParkingAtList( componentData );
			}
		} );
		
		bird.addEventListener( 'mousemove', ( evt ) => {
			if ( tooltip.classList.contains( TOOLTIP_SHOW_CLASS ) )
			{
				setTooltipCoords( componentData, evt.offsetX, evt.offsetY );
			}
		} );
	}
	
	scrollToParking( componentData );
};

const initFilters = ( componentData ) => {
	// Вынести фильтр в глобальные переменные
	
	const component = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.COMPONENT];
	const filtersButton = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.FILTERS_BUTTON];
	const filtersWrapper = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.FILTERS_WRAPPER];
	const filtersApplyButton = componentData[COMPONENT_DATA_KEY.NODES][NODE_NAME.FILTERS_APPLY_BUTTON];
	
	filtersButton.addEventListener( 'click', () => {
		component.classList.add( COMPONENT_CLASS.FILTERS_OPEN );
	} );
	
	filtersApplyButton.addEventListener( 'click', () => {
		component.classList.remove( COMPONENT_CLASS.FILTERS_OPEN );
	} );

	filtersWrapper.addEventListener( 'click', ( evt ) => {
		if ( component.classList.contains( COMPONENT_CLASS.FILTERS_OPEN ) && !evt.target.closest( 'div.content-wrapper' ) )
		{
			component.classList.remove( COMPONENT_CLASS.FILTERS_OPEN );
		}
	}, true );
};

const initComponentNodes = ( component ) => {
	const nodes = {};
	
	nodes[NODE_NAME.COMPONENT] = component;
	nodes[NODE_NAME.COUNT_PLACES_LABEL] = component.querySelector( 'p.places-count-label' );
	nodes[NODE_NAME.BACK_TO_PARKINGS_BUTTON] = component.querySelector( 'button.back-to-parkings' );
	nodes[NODE_NAME.PARKINGS_TOGGLE_WRAPPER] = component.querySelector( 'div.parkings-toggle-wrapper' );
	nodes[NODE_NAME.FILTERS_BUTTON] = component.querySelector( 'button.filters-button' );
	nodes[NODE_NAME.FILTERS_RESET_BUTTON] = component.querySelector( 'button.reset-filters' );
	nodes[NODE_NAME.FILTERS_WRAPPER] = component.querySelector( 'div.filters-wrapper' );
	nodes[NODE_NAME.PARKINGS_LIST] = component.querySelector( 'ul.parkings-list' );
	nodes[NODE_NAME.INTERACTIVE_WRAPPER] = component.querySelector( 'div.interactive-wrapper' );
	nodes[NODE_NAME.BOOK_PARKING_FORM] = component.querySelector( 'form.book-parking-form' );
	nodes[NODE_NAME.JSON_CONTAINER] = component.querySelector( JSON_CONTAINER_SELECTOR );
	
	if ( !nodes[NODE_NAME.FILTERS_WRAPPER] )
	{
		console.error( `${NODE_NAME.FILTERS_WRAPPER} не существует` );
		
		return;
	}
	
	nodes[NODE_NAME.PARKINGS_TOGGLE_BUTTON] = nodes[NODE_NAME.PARKINGS_TOGGLE_WRAPPER].querySelector( PARKINGS_TOGGLE_BUTTON_SELECTOR );
	nodes[NODE_NAME.PARKINGS_TOGGLE_LIST] = nodes[NODE_NAME.PARKINGS_TOGGLE_WRAPPER].querySelector( 'ul.parkings' );
	nodes[NODE_NAME.FILTERS_RANGE_WRAPPER] = nodes[NODE_NAME.FILTERS_WRAPPER].querySelector( 'div.range-wrapper' );
	nodes[NODE_NAME.FILTERS_COUNT_PLACES_LABEL] = nodes[NODE_NAME.FILTERS_WRAPPER].querySelector( 'p.places-count-label' );
	nodes[NODE_NAME.FILTERS_APPLY_BUTTON] = nodes[NODE_NAME.FILTERS_WRAPPER].querySelector( 'button.apply-filter' );
	nodes[NODE_NAME.FILTERS_CLOSE_BUTTON] = nodes[NODE_NAME.FILTERS_WRAPPER].querySelector( 'button.close-filter' );
	
	if ( !nodes[NODE_NAME.INTERACTIVE_WRAPPER] )
	{
		console.error( `${NODE_NAME.INTERACTIVE_WRAPPER} не существует` );
		
		return;
	}
	
	nodes[NODE_NAME.BIRD] = nodes[NODE_NAME.INTERACTIVE_WRAPPER].querySelector( 'div.bird' );
	nodes[NODE_NAME.SCHEME] = nodes[NODE_NAME.INTERACTIVE_WRAPPER].querySelector( `div.scheme[${GUID_ATTRIBUTE}]` );
	nodes[NODE_NAME.TOOLTIP] = nodes[NODE_NAME.INTERACTIVE_WRAPPER].querySelector( 'div.tooltip' );
	
	if ( !nodes[NODE_NAME.BIRD] )
	{
		console.error( `${NODE_NAME.BIRD} не существует` );
		
		return;
	}
	
	nodes[NODE_NAME.BIRD_SVG] = nodes[NODE_NAME.BIRD].querySelector( 'svg' );
	
	if ( nodes[NODE_NAME.BIRD_SVG] )
	{
		nodes[NODE_NAME.BIRD_SVG_PARKINGS] = nodes[NODE_NAME.BIRD_SVG].querySelector( BIRD_SVG_PARKING_WRAPPER_SELECTOR );
	}
	
	if ( !nodes[NODE_NAME.SCHEME] )
	{
		console.error( `${NODE_NAME.SCHEME} не существует` );
		
		return;
	}
	
	nodes[NODE_NAME.BOOK_PARKING_FORM_SUBMIT_BUTTON] = nodes[NODE_NAME.BOOK_PARKING_FORM].querySelector( 'button[type="submit"]' );
	nodes[NODE_NAME.BOOK_PARKING_FORM_INPUT_GUID] = nodes[NODE_NAME.BOOK_PARKING_FORM].querySelector( 'input[name="guid"]' );
	
	let isAllNodesExist = true;
	Object.entries( nodes ).forEach( ( [key, node] ) => {
		if ( !node && node !== nodes[NODE_NAME.BIRD_SVG] && node !== nodes[NODE_NAME.BIRD_SVG_PARKINGS] )
		{
			isAllNodesExist = false;
			
			console.error( `${key} не существует` );
		}
	} );
	
	if ( !isAllNodesExist )
	{
		return;
	}
	
	const complexData = JSON.parse( nodes[NODE_NAME.JSON_CONTAINER].getAttribute( JSON_CONTAINER_DATA_ATTRIBUTE ) );
	
	nodes[NODE_NAME.JSON_CONTAINER].remove();
	
	if ( !complexData )
	{
		return;
	}
	
	const componentData = {};
	componentData[COMPONENT_DATA_KEY.NODES] = nodes;
	componentData[COMPONENT_DATA_KEY.COMPLEX_DATA] = complexData;
	componentData[COMPONENT_DATA_KEY.CURRENT_STATE] = null;
	componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = null;
	componentData[COMPONENT_DATA_KEY.SCHEMES] = {};

	complexData[COMPLEX_FILTERED_DATA_KEY] = {};
	
	complexData.parkings.forEach( ( parking ) => {
		const {
			guid_building: guidParking,
			name_building: nameParking,
		} = parking;
		
		complexData[COMPLEX_FILTERED_DATA_KEY][guidParking] = {
			minPrice: 0,
			placesNumber: 0,
			guidParking,
			nameParking,
		};
		
		parking.floors.forEach( ( floor ) => {
			const {floor_number: floorNumber} = floor;
			
			if ( floor.status === 'sold' )
			{
				return;
			}
			
			if ( !complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors )
			{
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors = {};
			}
			
			complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber] = {
				minPrice: 0,
				placesNumber: 0,
				floorNumber,
			};
			
			if ( !complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].schemeSrc )
			{
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber].schemeSrc = floor['scheme_src'];
			}
			
			floor.parkings.forEach( ( place ) => {
				const {
					guid,
					price,
					hide_price: isHidePrice,
					number,
				} = place;
				
				const placeMinPrice = parseInt( price, 10 );
				const curentParkingMinPrice = complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].minPrice;
				const curentFloorMinPrice = complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber].minPrice;
				
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber][guid] = place;
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber][guid].filterAvailable = true;
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber][guid].number = number;
				
				if ( isHidePrice === 'no' && placeMinPrice !== 0 )
				{
					if ( curentParkingMinPrice === 0 || curentParkingMinPrice > placeMinPrice )
					{
						complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].minPrice = placeMinPrice;
					}
					
					if ( curentFloorMinPrice === 0 || curentFloorMinPrice > placeMinPrice )
					{
						complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber].minPrice = placeMinPrice;
					}
				}
				
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].placesNumber++;
				complexData[COMPLEX_FILTERED_DATA_KEY][guidParking].floors[floorNumber].placesNumber++;
			} );

			const filteredData = complexData[COMPLEX_FILTERED_DATA_KEY];

			Object.keys( filteredData ).forEach( ( it ) => {
				const parkingData = filteredData[it];

				if ( parkingData.minPrice === 0 )
				{
					document.querySelector( `li.parking-wrapper[data-guid="${it}"] p.price` ).innerHTML = 'Цена по запросу';
				}
			} );
		} );
	} );
	
	initParkingsList( componentData );
	initBackToParkingsButton( componentData );
	initParkingsToggle( componentData );
	initBird( componentData );
	initScheme( componentData );
	initFilters( componentData );
	
	if ( component.classList.contains( ONE_PARKING_CLASS ) )
	{
		nodes[NODE_NAME.BACK_TO_PARKINGS_BUTTON].remove();
		
		componentData[COMPONENT_DATA_KEY.CURRENT_PARKING_GUID] = Object.keys( complexData[COMPLEX_FILTERED_DATA_KEY] )[0];
		
		setStateFloorsBird( componentData );
		setStateFloorsScheme( componentData );
	}
	else if ( window.innerWidth >= BREAKPOINT )
	{
		setStateParkings( componentData );
	}
};

const initCds2Parking = () => {
	document.querySelectorAll( COMPONENT_SELECTOR ).forEach( ( component ) => {
		initComponentNodes( component );
	} );
};

export {
	initCds2Parking,
};
